import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { usePageTitle } from '../hooks/usePageTitle';
import PolicyCreateForm from '../components/PolicyCreateForm';
import { apiService, Policy } from '../services/api';

const PolicyCreate: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get('template');
  const [templatePolicy, setTemplatePolicy] = useState<Policy | null>(null);
  
  // Set page title
  usePageTitle(templatePolicy ? `Create Policy from Template` : 'Create Policy');

  // Fetch template policy if template ID is provided
  const { data: templateData, isLoading: isLoadingTemplate } = useQuery({
    queryKey: ['policy', templateId],
    queryFn: () => templateId ? apiService.getPolicyById(templateId) : null,
    enabled: !!templateId,
  });

  useEffect(() => {
    if (templateData) {
      setTemplatePolicy(templateData);
    }
  }, [templateData]);

  const handleClose = () => {
    navigate('/policies');
  };

  if (isLoadingTemplate) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-governate-500"></div>
      </div>
    );
  }

  return (
    <div className="flex h-full">
      {/* Main Content Area */}
      <div className="flex-1 bg-white">
        <PolicyCreateForm 
          onClose={handleClose} 
          templatePolicy={templatePolicy}
        />
      </div>
    </div>
  );
};

export default PolicyCreate;
